/**
 * 门户文本默认配置数据
 */
export const home = [
  {},
  {
    styleId:2,
    width: 224,
    height: 44,
    lineHeight: 44,
    fontSize: 32,
    fontWeight: 600,
    hoverFontSize: 44,
    hoverFontWeight: 600
  },
  {
    styleId:3,
    width: 196,
    height: 32,
    lineHeight: 32,
    fontSize: 28,
    fontWeight: 600,
    hoverFontSize: 28,
    hoverFontWeight: 600
  },
  {
    styleId:4,
    width: 168,
    height: 32,
    lineHeight: 32,
    fontSize: 24,
    fontWeight: 600,
    hoverFontSize: 24,
    hoverFontWeight: 600
  },
  {
    styleId:5,
    width: 140,
    height: 24,
    lineHeight: 24,
    fontSize: 20,
    fontWeight: 600,
    hoverFontSize: 20,
    hoverFontWeight: 600
  },
  {
    styleId:6,
    width: 126,
    height: 24,
    lineHeight: 24,
    fontSize: 18,
    fontWeight: 600,
    hoverFontSize: 18,
    hoverFontWeight: 600
  },
  {
    styleId:7,
    width: 112,
    height: 22,
    lineHeight: 22,
    fontSize: 16,
    fontWeight: 600,
    hoverFontSize: 16,
    hoverFontWeight: 600
  }
]

/**
 * 大屏文本默认配置数据
 */
export const bs = [
  {
    color: "rgba(255,255,255,1)",
    fontWeight: 600,
    fontSize: 21
  },
  {
    styleId:2,
    color: "rgba(255,255,255,1)",
    animateSets: {
      animateClass: "",
      animateDelay: 3,
      animateDirection: "横向",
      animateDuration: 6,
      animateTriggerNumType: "多次触发",
      animateType: 1,
      executionAnimateClass: "",
      hasDirection: true
    }
  }
]

/**
 * app文本默认配置数据
 */
 export const appHome = [
  {
    content: "新文本"
  },
  {
    styleId:2,
    width: 224,
    height: 44,
    lineHeight: 44,
    fontSize: 32,
    fontWeight: 600,
    hoverFontSize: 44,
    hoverFontWeight: 600
  },
  {
    styleId:3,
    width: 196,
    height: 32,
    lineHeight: 32,
    fontSize: 28,
    fontWeight: 600,
    hoverFontSize: 28,
    hoverFontWeight: 600
  },
  {
    styleId:4,
    width: 168,
    height: 32,
    lineHeight: 32,
    fontSize: 24,
    fontWeight: 600,
    hoverFontSize: 24,
    hoverFontWeight: 600
  },
  {
    styleId:5,
    width: 140,
    height: 24,
    lineHeight: 24,
    fontSize: 20,
    fontWeight: 600,
    hoverFontSize: 20,
    hoverFontWeight: 600
  },
  {
    styleId:6,
    width: 126,
    height: 24,
    lineHeight: 24,
    fontSize: 18,
    fontWeight: 600,
    hoverFontSize: 18,
    hoverFontWeight: 600
  },
  {
    styleId:7,
    width: 112,
    height: 22,
    lineHeight: 22,
    fontSize: 16,
    fontWeight: 600,
    hoverFontSize: 16,
    hoverFontWeight: 600
  }
]

/**
 * 门户详情页默认配置数据
 */
export const detailPrevPage = [
  {
    type: "prev",
    content: "上一篇",
    fontSize: 14,
    openBlankPage: false
  },
]
export const detailNextPage = [
  {
    type: "next",
    content: "下一篇",
    fontSize: 14,
    openBlankPage: false
  },
]
export const appDetailPrevPage = [
  {
    type: "prev",
    content: "上一篇",
    fontSize: 14,
    openBlankPage: false
  },
]
export const appDetailNextPage = [
  {
    type: "next",
    content: "下一篇",
    fontSize: 14,
    openBlankPage: false
  },
]

